import { render, staticRenderFns } from "./form-tags_ratersPool.vue?vue&type=template&id=53d560fc&"
import script from "./form-tags_ratersPool.vue?vue&type=script&lang=js&"
export * from "./form-tags_ratersPool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports